module.exports = __webpack_public_path__ + "img/icon-warning.99a60785.svg";